module.exports = __webpack_public_path__ + "img/home_pic_up_4.cbbc325b.png";